<template>
  <div class="modal-wrapper">
    <div class="modal" v-on-clickaway="closeModal">
      <h3>
        {{
          modal && modal.title
            ? $t(modal.title)
            : $t("modal-error-default-message")
        }}
      </h3>
      <p v-if="modal && modal.text">{{ $t(modal.text) }}</p>
      <footer>
        <button type="button" class="primary" @click="closeModal">
          {{ $t("modal-ok-button") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import { mapState, mapActions } from "vuex";

export default {
  name: "Modal",
  mixins: [clickaway],
  computed: {
    ...mapState("common", ["modal"])
  },
  methods: {
    ...mapActions("common", ["hideModal"]),
    closeModal() {
      this.hideModal();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/styles/variables";

.modal-wrapper {
  z-index: 6;
  .modal {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    position: relative;
    width: 50%;
    max-width: 700px;
    border: 1px solid $middle-gray;
    border-radius: 8px;
    padding: 10px 20px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    background: white;
    footer {
      margin: 30px 0 10px 0;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
